<a href="https://wa.me/6281210053430?text=Halo%20Kak,%20Saya%20ingin%20kirim%20paket,%20Apakah%20bisa%20dibantu"
    class="float" target="_blank">
    <i class="fab fa-whatsapp my-float"></i>
</a>